import { Outlet } from 'react-router-dom';

function Creditos() {
  return <Outlet />;
}

export default Creditos;
